export default __webpack_public_path__ + "static/media/criadoras.bcb5cba8.svg";